import {createAsyncThunk} from '@reduxjs/toolkit';
import {
  getEmojiCategories,
  setSiteEmojiCategories,
  getSiteEmojiConfiguration,
  getProductTypeAccess,
  getAccountProducts,
  sendProductTypeAccessRequest,
} from './api/ppa'

import {
  getCodeForSite,
  getSiteConfiguration,
  setSiteConfiguration,
  getMigrationStatus,
  setMigration,
} from './api/asu'

import {
  getTrendingNowCodeForSite,
  getTrendingNowConfiguration,
  setTrendingNowConfiguration
} from './api/tnu'

export const PRODUCT_ARTICLE_SENTIMENT = 'ARTICLE_SENTIMENT';
export const PRODUCT_RATINGS = 'RATINGS';
export const PRODUCT_COMMENTING = 'COMMENTING';
export const PRODUCT_REQUEST_PENDING = 'PENDING';
export const MIGRATION_STATUS_STARTED = 'STARTED';
export const PRODUCT_TRENDING_NOW = 'TRENDING_NOW';

export const fetchCodeForSite = createAsyncThunk(
  'engagement/fetchCodeForSite',
  async accountUUID => {
    const response = await getCodeForSite(accountUUID);
    return response.data
  });

export const fetchTrendingNowCodeForSite = createAsyncThunk(
  'engagement/fetchTrendingNowCodeForSite',
  async siteUUid => {
    const response = await getTrendingNowCodeForSite(siteUUid);
    return response.data
  });

export const fetchSiteConfiguration = createAsyncThunk(
  'engagement/fetchSiteConfiguration',
  async (config) => {
    const response = await getSiteConfiguration(config);
    return response.data
  });

export const updateSiteConfiguration = createAsyncThunk(
  'engagement/updateSiteConfiguration',
  async (config) => {
    const response = await setSiteConfiguration(config);
    return response.data
  });

export const fetchTrendingNowConfiguration = createAsyncThunk(
  'engagement/fetchTrendingNowConfiguration',
  async (config) => {
    const response = await getTrendingNowConfiguration(config);
    return response.data
  });

export const updateTrendingNowConfiguration = createAsyncThunk(
  'engagement/updateTrendingNowConfiguration',
  async (config) => {
    const response = await setTrendingNowConfiguration(config);
    return response.data
  });

export const fetchMigrationStatus = createAsyncThunk(
  'engagement/fetchMigrationStatus',
  async articleSentimentUnitUUID => {
    const response = await getMigrationStatus(articleSentimentUnitUUID);
    return response.data
  });

export const startMigration = createAsyncThunk(
  'engagement/startMigration',
  async articleSentimentUnitUUID => {
    const response = await setMigration({articleSentimentUnitUUID, migrationStatus: MIGRATION_STATUS_STARTED});
    return response.data
  });

export const fetchSiteEmojiConfiguration = createAsyncThunk(
  'engagement/fetchSiteEmojiConfiguration',
  async siteUUID => {
    const response = await getSiteEmojiConfiguration(siteUUID);
    return response.data
  });

export const fetchEmojiCategories = createAsyncThunk(
  'engagement/fetchEmojiCategories',
  async () => {
    const response = await getEmojiCategories();
    return response.data
  });

export const updateSiteEmojiCategories = createAsyncThunk(
  'engagement/updateSiteEmojiCategories',
  async (config) => {
    const response = await setSiteEmojiCategories(config);
    return response.data
  });

export const fetchArticleSentimentAccess = createAsyncThunk(
  'engagement/fetchArticleSentimentAccess',
  async (accountUUID) => {
    const response = await getProductTypeAccess({accountUUID, productType: PRODUCT_ARTICLE_SENTIMENT});
    return response.data
  });

export const sendArticleSentimentAccessRequest = createAsyncThunk(
  'engagement/sendArticleSentimentAccessRequest',
  async (accountUUID) => {
    const response = await sendProductTypeAccessRequest({accountUUID, productType: PRODUCT_ARTICLE_SENTIMENT});
    return response.data
  });

export const fetchTrendingNowAccess = createAsyncThunk(
  'engagement/fetchTrendingNowAccess',
  async (accountUUID) => {
    const response = await getProductTypeAccess({accountUUID, productType: PRODUCT_TRENDING_NOW});
    return response.data
  });

export const sendTrendingNowAccessRequest = createAsyncThunk(
  'engagement/sendTrendingNowAccessRequest',
  async (accountUUID) => {
    const response = await sendProductTypeAccessRequest({accountUUID, productType: PRODUCT_TRENDING_NOW});
    return response.data
  });

export const fetchAccountProducts = createAsyncThunk(
  'engagement/fetchAccountProducts',
  async (accountUUID) => {
    const response = await getAccountProducts(accountUUID);
      console.log(response.data)
      return response.data
  });

